// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 768px)";
var _3 = "root-1xKtg";
var _4 = "header-2HvjB";
var _5 = "header__icon-2sytk";
var _6 = "forbidden-3XEvz";
var _7 = "allowed-D-PRw";
var _8 = "title__wrapper-2BAe6";
var _9 = "title-3RaK3";
var _a = "subtitle-2eqdW";
var _b = "line-3bFzo";
var _c = "content-1Levf";
var _d = "image-n6iTa";
var _e = "list-3WvxA";
var _f = "item-2cOhD";
var _10 = "item__title-2DM8K";
var _11 = "item__description-EVVoE";
var _12 = "item__tooltip-3wvXc";
var _13 = "item__tooltip_arrow-5Z198";
var _14 = "item__icon-miqKB";
export { _1 as "__esModule", _2 as "tabletMiddle", _3 as "root", _4 as "header", _5 as "header__icon", _6 as "forbidden", _7 as "allowed", _8 as "title__wrapper", _9 as "title", _a as "subtitle", _b as "line", _c as "content", _d as "image", _e as "list", _f as "item", _10 as "item__title", _11 as "item__description", _12 as "item__tooltip", _13 as "item__tooltip_arrow", _14 as "item__icon" }
export default { "__esModule": _1, "tabletMiddle": _2, "root": _3, "header": _4, "header__icon": _5, "forbidden": _6, "allowed": _7, "title__wrapper": _8, "title": _9, "subtitle": _a, "line": _b, "content": _c, "image": _d, "list": _e, "item": _f, "item__title": _10, "item__description": _11, "item__tooltip": _12, "item__tooltip_arrow": _13, "item__icon": _14 }
